import { module } from 'angular';
import { react2angular } from 'react2angular';

import { ExecutionStepDetails } from './ExecutionStepDetails';

export const EXECUTION_STEP_DETAILS_COMPONENT = 'spinnaker.core.pipeline.config.stages.core.executionStepDetails.component';
module(EXECUTION_STEP_DETAILS_COMPONENT, [])
  .component('executionStepDetails', react2angular(ExecutionStepDetails, ['item']));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/config/stages/core/executionStepDetails.component.ts